import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Form from '../../Components/Boilerplates/Forms/Forms';
import layer from '../../assets/Layer.png';
import { useMemo } from 'react';
import ListF from './ListF/ListF';
import Users from './Users';

const manageTypes = {
  CreateUser: {
    type: 'form',
    inputs: [
      {
        id: 'firstname',
        elementConfig: { type: 'text', placeholder: 'نام' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
      {
        id: 'lastname',
        elementConfig: { type: 'text', placeholder: 'نام خانوادگی' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
      {
        id: 'username',
        elementConfig: { type: 'text', placeholder: 'نام کاربر' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
      {
        id: 'password',
        elementConfig: { type: 'text', placeholder: 'رمز عبور' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
      {
        id: 'groupname',
        elementConfig: { type: 'text', placeholder: 'نام گروه' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
    ],
    url: 'create/user/',
    title: 'کاربر جدید',
  },
  CreateGroup: {
    type: 'form',
    before: (
      <div className='center'>
        <img alt='group' src={layer} style={{ width: '150px', padding: '2rem 0' }} />
      </div>
    ),
    inputs: [
      {
        id: 'groupname',
        elementConfig: { type: 'text', placeholder: 'نام گروه' },
        value: '',
        validation: { required: true },
        valid: false,
        touched: false,
      },
    ],
    url: 'create/group/',
    title: 'گروه جدید',
  },
  AllGroups: {
    type: 'list-1',
  },
  AllUsers: {
    type: 'list-2',
  },
};

const Manage = () => {
  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...manageTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);

  const theReturn = useMemo(() => {
    switch (thisPageData.type) {
      case 'list-1':
        return <ListF {...thisPageData} />;
      case 'list-2':
        return <Users />;
      case 'form':
      default:
        return (
          <Form
            inputs={thisPageData.inputs}
            url={thisPageData.url}
            pageTitle={thisPageData.title ? 'ایجاد ' + thisPageData.title : ''}
            header={{ Authorization: `Bearer ${token}` }}
            goBack='UserManager'
            beforeForm={thisPageData.before}
            btnText='ایجاد'
            btnStyle={{
              alignSelf: 'flex-start',
              borderRadius: '25px',
              width: '100px',
              marginLeft: '2rem',
              fontWeight: 'bold',
            }}
          />
        );
    }
  }, [thisPageData, token]);

  return theReturn;
};

export default Manage;
